<router-outlet></router-outlet>

<div id="install-card" class="install-card" hidden>
  <div class="install-card-content">
    <p>Instale o nosso app para uma melhor experiência!</p>
    <button id="install-button" class="install-button">Instalar</button>
  </div>
  <button id="dismiss-button" class="dismiss-button">&times;</button>
</div>
